import { IconProps } from 'types/icon.type'

export const EyeIcon = (props: IconProps) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Eye icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4998 4.79224C8.84942 4.79224 7.23623 5.28227 5.86471 6.20021C4.49727 7.11542 3.43147 8.41491 2.80151 9.93475C2.78752 9.97716 2.78752 10.023 2.80151 10.0654C3.43147 11.5852 4.49727 12.8847 5.86471 13.7999C7.23623 14.7178 8.84942 15.2079 10.4998 15.2079C12.1501 15.2079 13.7633 14.7178 15.1348 13.7999C16.5023 12.8847 17.5681 11.5852 18.198 10.0654C18.212 10.023 18.212 9.97716 18.198 9.93474C17.5681 8.4149 16.5023 7.11542 15.1348 6.20021C13.7633 5.28227 12.1501 4.79224 10.4998 4.79224ZM5.16945 5.1614C6.74669 4.10577 8.60186 3.54224 10.4998 3.54224C12.3977 3.54224 14.2528 4.10577 15.8301 5.1614C17.4073 6.21703 18.6356 7.71722 19.3592 9.47176C19.3621 9.47865 19.3648 9.48558 19.3674 9.49256C19.4889 9.81997 19.4889 10.1801 19.3674 10.5076C19.3648 10.5145 19.3621 10.5215 19.3592 10.5283C18.6356 12.2829 17.4073 13.7831 15.8301 14.8387C14.2528 15.8943 12.3977 16.4579 10.4998 16.4579C8.60186 16.4579 6.74669 15.8943 5.16945 14.8387C3.59221 13.7831 2.36392 12.2829 1.64031 10.5283C1.63747 10.5215 1.63476 10.5145 1.63217 10.5076C1.51063 10.1801 1.51063 9.81997 1.63217 9.49256C1.63476 9.48558 1.63747 9.47865 1.64031 9.47176C2.36392 7.71722 3.59221 6.21703 5.16945 5.1614Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4998 8.12506C9.46424 8.12506 8.62477 8.96452 8.62477 10.0001C8.62477 11.0356 9.46424 11.8751 10.4998 11.8751C11.5353 11.8751 12.3748 11.0356 12.3748 10.0001C12.3748 8.96452 11.5353 8.12506 10.4998 8.12506ZM7.37477 10.0001C7.37477 8.27417 8.77388 6.87506 10.4998 6.87506C12.2257 6.87506 13.6248 8.27417 13.6248 10.0001C13.6248 11.7259 12.2257 13.1251 10.4998 13.1251C8.77388 13.1251 7.37477 11.7259 7.37477 10.0001Z"
        fill="currentColor"
      />
    </svg>
  )
}
